<template>
    <div class="CreateCluster">
        <el-card class="box-card">
            <span class="title">Cluster Details</span>

            <div v-loading="is_cluser_details_loading">
                <div class="mt-10" >
                    <el-row class="form-inputs">
                        <el-col :xs="12" :sm="12" :md="4" :lg="4" :xl="4">
                            <label>Cluster Name</label>
                        </el-col>
                        <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
                            <el-input v-model="cluster_name" v-validate="disabled_error_on_empty ? 'required' : ''" placeholder="Enter cluster name" name="Cluster Name" size="medium" class="input"></el-input>

                            <span v-show="errors.has('Cluster Name')" class="text-red-dark text-xs">
                                {{ errors.first("Cluster Name") }}
                            </span>
                        </el-col>
                    </el-row>

                    <!-- <div class="form-inputs mt-6">
                        <el-col :xs="12" :sm="12" :md="4" :lg="4" :xl="4">
                            <label>Add By</label>
                        </el-col>
                        <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
                            <el-select v-model="add_by" size="medium" class="input">
                                <el-option v-for="(filter, filter_index) in filter_list" :key="filter_index" :value="filter.value" :title="filter.title"></el-option>
                            </el-select>
                        </el-col>
                    </div> -->

                    <div class="form-inputs mt-8">
                        <el-col :xs="12" :sm="12" :md="4" :lg="4" :xl="4">
                            <label>Select Stores</label>
                        </el-col>
                        <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
                            <el-select v-model="select_store" placeholder="Select store" name="Select Store" size="medium" class="input capitalize"  multiple collapse-tags filterable @change="selectStore()">
                                <el-option v-for="(store, store_index) in outlets_list" :key="store_index" :value="store.id" :label="store.name" class="capitalize"></el-option>
                            </el-select>

                            <!-- <span v-show="errors.has('Select Store')" class="text-red-dark text-xs">
                                {{ errors.first("Select Store") }}
                            </span> -->
                        </el-col>
                    </div>
                </div>

                <div class="mt-10">
                    <table>
                        <thead>
                            <tr>
                                <th>STORE NAME</th>
                                <th>REGION</th>
                                <th>SUB REGION</th>
                                <th>&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(store, st_index) in selected_outlets_list" :key="st_index">
                                <td class="capitalize">{{ store.name }}</td>
                                <td class="capitalize">{{ store.region_name }}</td>
                                <td class="capitalize">{{ store.sub_region_name }}</td>
                                <td><img src="../../../assets/images/delete-icon.png" @click="deleteStore(st_index)"></td>
                            </tr>
                        </tbody>
                    </table>

                    <div v-if="!selected_outlets_list.length" class="no-data-notification">
                        No data available
                    </div>
                </div>

                <div class="btn-section mt-6">
                    <el-button class="action-btn" size="small" @click="goToClusterListPage()">CANCEL</el-button>
                    <el-button class="action-btn" size="small" :loading="is_cluser_details_save_in_progress" @click="updateCluster()">UPDATE</el-button>
                </div>
            </div>
        </el-card>
    </div>
</template>

<script>
import axios from 'axios';
import labourPlanningService from '../../../services/labourPalnningService';
import userAccountsService from '../../../services/userAccountsService';
import { EventBus } from '../../../eventBus.js';

export default {
    name: 'CreateCluster',
    
    data() {
        return {
            cluster_name: '',
            add_by: '',
            filter_list: [
                {
                    title: 'Country',
                    value: 'country'
                },
                {
                    title: 'Region',
                    value: 'region'
                },
                {
                    title: 'Sub-Region',
                    value: 'subregion'
                },
                {
                    title: 'Stores',
                    value: 'store'
                }
            ],
            outlets_list: [],
            select_store: [],
            selected_outlets_list: [],
            region_list: [],
            sub_region_list: [],
            disabled_error_on_empty: false,
            is_cluser_details_save_in_progress: false,
            is_cluser_details_loading: false,
        }
    },

    mounted(){
        this.getCombinedClusteDetails();
    },

    methods: {
        selectStore(){
            this.selected_outlets_list = [];
            
            // filter outlets
            for(let i=0; i<this.select_store.length; i++){
                
                // console.log(this.selected_outlets_list.some( ({id}) => id == this.select_store[i]))
                // if(!this.selected_outlets_list.some( ({id}) => id == this.select_store[i])){
                    let filterd_outlet = this.outlets_list.filter(e =>{
                        return e.id == this.select_store[i];
                    })[0];
        
                    // filter region
                    let region = this.region_list.filter(e =>{
                        return e.id == filterd_outlet.region;
                    })[0];
        
                    filterd_outlet.region_name = region.name;
        
                    // filter subregion
                    let sub_region = this.sub_region_list.filter(e =>{
                        return e.id == filterd_outlet.subregion;
                    })[0]
        
                    filterd_outlet.sub_region_name = sub_region.name;
        
                    this.selected_outlets_list.push(filterd_outlet);
                // }
            }
        },

        deleteStore(st_index){
            // first removed selected store from select store dropdown and then from table
            this.select_store.splice(this.select_store.indexOf(this.selected_outlets_list[st_index].id), 1);
            this.selected_outlets_list.splice(st_index, 1);
        },

        goToClusterListPage(){
            this.clearForm();

            // this.$store.commit('setActiveAccountDetailsTab', 'CLUSTER_DETAILS');        //set active cluster tab on app store details page

            this.$router.push({path: '/app-store-details', query: {tab: 'CLUSTER_DETAILS'}}) //redirect to app store details page - cluster tab
        },

        // api to update cluster
        updateCluster(){
            this.disabled_error_on_empty = true;

            setTimeout(() => {
                this.$validator.validateAll().then(result => {
                    if(result){
                        let outlets_list = [];
    
                        for(let i=0; i<this.selected_outlets_list.length; i++){
                            outlets_list.push(this.selected_outlets_list[i].id);
                        }
    
                        if(outlets_list.length){
                            this.is_cluser_details_save_in_progress = true;      //enabled loader
    
                            let params = {
                                name: this.cluster_name,
                                outlets: outlets_list
                            }

                            if(this.$route.query.id){
                                params.id = Number(this.$route.query.id);
                            }
        
                            labourPlanningService.saveCluster(params)
                            .then(response => {
                                if(response.status == 200){
                                    this.$notify.success({
                                        title: "Success",
                                        message: "Cluster created successfully..!"
                                    });
                                    
                                    this.clearForm();   //called function to clear form

                                    this.$router.push({path: '/app-store-details', query: {tab: 'CLUSTER_DETAILS'}})   //redirect to app store details page - cluster tab
                                            //set active cluster tab on app store details page
                                }
    
                                this.is_cluser_details_save_in_progress = false;     //disabled loader
                            })
                            .catch(err => {
                                console.log(err);
                                this.$notify.error({
                                    title: "Error",
                                    message: err.response.data
                                });
                                
                                this.is_cluser_details_save_in_progress = false;     //disabled loader
                                this.$forceUpdate();
                            });
                        }else{
                            this.$notify.error({
                                title: "Error",
                                message: "Select atlease one store..!"
                            });
                            this.is_cluser_details_save_in_progress = false;
                        }
                    }
                })
            }, 100);
        },

        // get combined response
        getCombinedClusteDetails(){
            this.is_cluser_details_loading = true;  //enabled loader

            axios.all([this.getAllRegions(), this.getAllSubRegions(), this.getOutletsList()])
            .then(axios.spread(async function(allRegionsRes, allSubRegionsRes, allOutletsRes) {
                
                if(allRegionsRes.status == 200 && allSubRegionsRes.status == 200 && allOutletsRes.status == 200 && allOutletsRes.status){

                    let all_regions_list = JSON.parse(allRegionsRes.data);
                    let all_sub_regions_list = JSON.parse(allSubRegionsRes.data);
                    let all_outlets_list = JSON.parse(allOutletsRes.data);

                    if(all_regions_list.length){
                        this.region_list = all_regions_list;
                    }
    
                    if(all_sub_regions_list.length){
                        this.sub_region_list = all_sub_regions_list;
                    }
    
                    if(all_outlets_list.length){
                        this.outlets_list = all_outlets_list.filter(e => {
                            if (e.type == "store") {
                                return e;
                            }
                        })
                    }

                    // if cluser id in route -- to get cluster details by id -- for edit cluster
                    if(this.$route.query.id){
                        let clusterDetailsRes = await this.getClusterDetails();

                        if(clusterDetailsRes.status == 200){
                            this.select_store = [];

                            let cluster_details = JSON.parse(clusterDetailsRes.data);

                            for(let i=0; i<cluster_details.outlets.length; i++){
                                // filter outlets
                                let filterd_outlet = this.outlets_list.filter(e =>{
                                    return e.id == cluster_details.outlets[i].id;
                                })[0];

                                // filter region
                                let region = this.region_list.filter(e =>{
                                    return e.id == filterd_outlet.region;
                                })[0]

                                filterd_outlet.region_name = region.name;

                                // filter subregion
                                let sub_region = this.sub_region_list.filter(e =>{
                                    return e.id == filterd_outlet.subregion;
                                })[0]

                                filterd_outlet.sub_region_name = sub_region.name;

                                this.select_store.push(cluster_details.outlets[i].id);     //pushed outlest in select store dropdown to show selected outlets
                                
            
                                this.selected_outlets_list.push(filterd_outlet);
                            }
        
                            this.cluster_name = cluster_details.name;
                        }
                    }

                    // console.log('getCombinedClusteDetails', this.region_list, this.sub_region_list, this.outlets_list, this.cluster_name);
                }

                this.is_cluser_details_loading = false;  //disabled loader

            }.bind(this)))
            .catch(errors => {
                this.is_cluser_details_loading = false;  //disabled loader
            })
            .finally(() => {
                this.is_cluser_details_loading = false;  //disabled loader
            });
        },

        // api to get regions
		getAllRegions() {
			return userAccountsService.getAllRegion()
            .then(response => {
                return response;
            })
            .catch(err => {
                console.log(err);
            });
        },

        // api to get regions
		getAllSubRegions() {
			return userAccountsService.getAllSubRegion()
            .then(response => {
                return response;
            })
            .catch(err => {
                console.log(err);
            });
        },

        // api to get all outlets list
		getOutletsList() {
			return labourPlanningService.getAllStoreDataCluster()
            .then(response => {
                return response;
            })
            .catch(err => {
                console.log(err);
            });
        },

        // api to get cluster details
		getClusterDetails() {
            // if(this.$route.query.id){
                return labourPlanningService.getClusterDetailsById(this.$route.query.id)
                .then(response => {
                    return response;
                })
                .catch(err => {
                    console.log(err);
                });
            // }
        },

        clearForm(){
            this.disabled_error_on_empty = false;
            this.select_store = "";
            this.cluster_name = "";
            this.selected_outlets_list = [];
        }
    },
}
</script>
<style lang="scss" scoped>
.CreateCluster{
    .title{
        border-bottom: 2px solid #e29d5a;
        padding: 5px 0px;
        font-size: 14px;
        font-weight: bold;
    }
    .form-inputs{
        display: flex;
        align-items: center;
        label{
            font-size: 13px;
            font-weight: bold;
        }
        .input{
            width: 100%;
        }
    }
    table {
        width: 100%;
        border-collapse: collapse;
        border-spacing: 0;
        // border: 1px solid #bebebe;
    }

    thead th {
        height: 40px;
        color: #707070;
        background-color: #f2f2f2!important;
        text-transform: uppercase;
    }

    tbody td, thead th {
        // height: 50px;
        padding: 5px 40px;
        font-size: 13px;
    }

    tbody tr{
        border-bottom: 1px solid #eee;
    }

    td{
        text-align: center;
        height: 50px;
        img{
            width: 18px;
            cursor: pointer;
        }
    }
    td:first-child, th:first-child {
        text-align: left;
    }
    .btn-section{
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }
    .action-btn {
        background-color: #E29D5A;
        border-color: #E29D5A;
        color: #fff;
    }
    .no-data-notification{
        text-align: center;
        font-size: 14px;
        font-weight: 600;
        color: #e29d5a;
        padding: 15px;
    }
}
</style>